module.exports = "<div class=\"app-LandingPage\">THIS IS THE LANDING PAGE - You last accessed this page : {{ lastAccessed }}</div>"